import React, { useEffect, useState } from "react";

import { teamInitials } from "./competitionsFormat";

// Crest for the competitions embeddables — UI-SPEC optics (§7 row anatomy):
// square, border-radius 2px, #F1F5FA ground, 1px #E2E8F0 border, monogram
// fallback 700 #475569. NEW shared component on purpose: the StandingsWidget's
// TeamLogo is a local, differently-styled component and must not be copied or
// modified here (the lead consolidates extraction later).
//
// `team` may be null/undefined — renders the quiet empty box (bracket TBD
// slots keep the crest footprint without inventing anything).
const TeamCrest = ({ team, size = 26 }) => {
  const [errored, setErrored] = useState(false);
  useEffect(() => {
    setErrored(false);
  }, [team && team.logo]);

  const hasLogo = Boolean(team && team.logo) && !errored;
  if (hasLogo) {
    return (
      <img
        src={team.logo}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        onError={() => setErrored(true)}
        className="tp-comp-crest"
        style={{
          width: size,
          height: size,
          borderRadius: 2,
          objectFit: "contain",
          background: "#fff",
          flex: "none",
        }}
      />
    );
  }

  const initials = team ? teamInitials(team) : "";
  return (
    <span
      className="tp-comp-crest"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: 2,
        background: "#F1F5FA",
        border: "1px solid #E2E8F0",
        color: "#475569",
        fontWeight: 700,
        fontSize: Math.max(7, Math.round(size * 0.33)),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "none",
        boxSizing: "border-box",
      }}
    >
      {initials}
    </span>
  );
};

export default TeamCrest;
